export default "__VITE_ASSET__CwHLGnML__"